import {
    Component,
    ContentChildren,
    Input,
    OnInit,
    QueryList,
} from '@angular/core';
import {ToastrService} from 'ngx-toastr';
import {StepperComponent} from '../stepper/stepper.component';
import { Route, Router } from '@angular/router';
import { ToastNotificationService } from "app/shared/toast-notification/toast-notification.service";

@Component({
    selector: 'app-stepper-container',
    templateUrl: './stepper-container.component.html',
    styleUrls: ['./stepper-container.component.css'],
})
export class StepperContainerComponent implements OnInit {
    @ContentChildren(StepperComponent) steppers: QueryList<StepperComponent> =
        new QueryList();

    @Input() isAllowedToNavigate: Boolean = false;
    IsCompliance = false;

    activeStepper: StepperComponent;

    constructor(private msg: ToastrService , private Route: Router , private toastService: ToastNotificationService) {
    }

    ngOnInit(): void {
        if(this.Route.url.includes("compliance-process")){
            this.IsCompliance = true;
        }
    }

    ngAfterContentInit(): void {
        this.activeStepper = this.steppers?.find(
            (stepper) => stepper.active === true
        );

        if (!this.activeStepper) {
            this.selectStepper(this.steppers!.first);
        }
    }

    selectStepper(stepper: StepperComponent) {
        this.steppers?.forEach((stepper) => {
            stepper.active = false;
        });

        stepper.active = true;
        this.activeStepper = stepper;

        return false;
    }

    moveStepper(index: number) {
        this.activeStepper.isProgress == 'false';
        this.selectStepper(this.steppers.toArray()[index]);
    }

    jumpStepper(stepper: StepperComponent) {

        let currentIndex = this.steppers.toArray().indexOf(this.activeStepper);
        let newIndex = this.steppers.toArray().indexOf(stepper);

        if (!this.isAllowedToNavigate && this.IsCompliance)  {
            this.toastService.error(
                `Please click the buttons below for navigation`,
                "Navigation"
              );
            return;
        }

        if (!this.isAllowedToNavigate) {
            if (this.activeStepper.isProgress === 'true' && currentIndex < newIndex) {
                this.msg.warning('Current stage needs to be completed first');
                return;
            }
        }

        for (let i = 0; i < newIndex; i++) {
            let stepper = this.steppers.toArray()[i];
            stepper.isProgress = 'false';
        }

        this.selectStepper(stepper);

    }

    next() {

        let index = this.steppers.toArray().indexOf(this.activeStepper);
        if (index >= 0 && index < this.steppers.toArray().length - 1) {
            this.selectStepper(this.steppers.toArray()[index + 1]);
        }
    }

    previous() {
        const index = this.steppers.toArray().indexOf(this.activeStepper);
        const prevIndex = index - 1;

        if (this.steppers.toArray()[prevIndex]) {
            this.selectStepper(this.steppers.toArray()[prevIndex]);
        }
    }
}
